import React from 'react';
/**
 * LongDivisionRenderer — Wrapper adapting LongDivision to renderer interface.
 *
 * DDD co-locatie: moved from components/practice/renderers/ in s66.
 *
 * The inner <LongDivision> already owns the rising-edge submit (it fires
 * onComplete(userInputs.join('')) once when shouldValidate flips true), so we
 * forward it straight to onAnswer. A previous wrapper-level second edge
 * detector read a buffered answer one tick too early and submitted an empty
 * string, marking every answer wrong.
 */
import { QuestionRendererProps } from './types';
import { LongDivision } from '../LongDivision';
export function LongDivisionRenderer({
  question,
  onAnswer,
  onReadyChange,
  shouldValidate
}: QuestionRendererProps) {
  return <LongDivision question={question} onComplete={onAnswer} onReadyChange={onReadyChange} shouldValidate={shouldValidate} data-id="element-12226" data-mp="qhq93na6wcsg" />;
}